@if (isOpen()) {
  <div class="lightbox-backdrop" (click)="onBackdropClick($event)">
    <button class="lightbox-close" (click)="close()">
      <span class="material-symbols-outlined">close</span>
    </button>

    @if (currentIndex() > 0) {
      <button class="lightbox-nav prev" (click)="prev()">
        <span class="material-symbols-outlined">chevron_left</span>
      </button>
    }

    @if (currentImage) {
      <img
        class="lightbox-image"
        [src]="getUrl(currentImage)"
        [alt]="currentImage.fileName"
      />
    }

    @if (currentIndex() < images.length - 1) {
      <button class="lightbox-nav next" (click)="next()">
        <span class="material-symbols-outlined">chevron_right</span>
      </button>
    }
  </div>
}
